<template>
    <footer>
        <div id="footer" class="footer">
            <v-btn id="faq-button-footer" class="faq-button" fab color="secondary" absolute @click.stop="showContextHelp = !showContextHelp">
                <v-icon>$vuetify.icon.questionCircle</v-icon>
            </v-btn>
        </div>
        <FAQDrawer v-model="showContextHelp" />
        <LearnHowDrawer
            v-model="showLearnHowDrawer"
            :learnHowPaymentPlan="learnHowPaymentPlan"
            :providerKey="planProviderKey"
        />
    </footer>
</template>

<script>

import FAQDrawer from "@/components/drawer/FAQDrawer.vue";
import LearnHowDrawer from "@/components/drawer/LearnHowDrawer.vue";
import { mapState } from "vuex"
import {learnHowState} from "@/state";

    export default {
        components: {
            FAQDrawer,
            LearnHowDrawer,
        },
        data() {
            return {
                showContextHelp: false,
            }
        },
        computed: {
            ...mapState("learnHow", {
                learnHowPaymentPlan: state => state.learnHowPaymentPlan,
                learnHowDrawerVisible: state => !!state.learnHowDrawerVisible
            }),

            showLearnHowDrawer: {
                get() {
                    return this.learnHowDrawerVisible
                },

                set(visible) {
                    learnHowState.drawerVisible = visible
                }
            },


            planProviderKey() {
                return this.learnHowPaymentPlan?.providerKey
            },
        },
    }
</script>

<style lang="scss" scoped>
    .footer {
        position: fixed;
        right: 0;
        padding-right: 5vw;
        bottom: 100px;
        display: flex;
        justify-content: flex-end;
        align-content: flex-end;
        align-items: flex-end;
        width: 95%;
        margin: auto;
    }

    .faq-button {
        margin: auto;
    }

    .navigation-drawer {
        width: 560px !important;
    }

    @media only screen and (max-width: 960px) {
        .footer {
            display: none;
        }
    }

    .v-btn--fab.v-size--default {
        background: #fff !important;
        color: $secondary-color !important;
        min-height: to_rem(56px) !important;
    }

    .v-menu__content {
        width: to_rem(770px);
        max-width: to_rem(770px);
        margin: auto;
        overflow-y: scroll;
        max-height: 90vh;
    }

    .v-btn--fab.v-size--default {
        background: #fff !important;
        color: $secondary-color !important;
        min-height: to_rem(56px) !important;
    }

    .v-tab {
        font-style: normal;
        font-weight: 350;
        font-size: to_rem(14px);
        line-height: to_rem(20px);
        text-align: center;
        color: $grey-darken-2;
        border-bottom: to_rem(2px) solid $grey-lighten-1;
        &.v-tab--active {
            font-weight: 600;
            color: $secondary-color;
        }
    }

    .v-expansion-panel {
        &:before {
            box-shadow: 0 1px 1px rgb(0 0 0 / 10%);
        }

        .v-expansion-panel-header {
            font-style: normal;
            font-weight: 600;
            font-size: to_rem(18px);
            line-height: to_rem(28px);

            color: $primary-color;
        }
    }

    .v-card__title {
        display: flex;
        justify-content: space-between;
        padding-left: to_rem(16px);
        padding-top: to_rem(24px);
        padding-right: to_rem(22px);
        h1 {
            font-style: normal;
            font-weight: 600;
            font-size: to_rem(22px);
            line-height: to_rem(28px);
            letter-spacing: -0.5px;
            color: $primary-color;
        }
    }

    .v-overlay__scrim {
        height: 100%;
    }

    .relative {
        position: relative;
    }

    button {
        position: absolute !important;
        z-index: 20 !important;
        top: 30px;
        right: 23px;
    }

    .close {
        stroke: $grey-darken-2 !important;
    }
</style>
